export function DiagonalLineIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#diagonal-line-clip)">
        <path
          d="M11 3L5 13"
          stroke={"currentColor"}
          strokeOpacity="0.64"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="diagonal-line-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
